
<button mat-button color="primary" fxHide.gt-md (click)="userManual()">
  <mat-icon matTooltip="User Manual">book</mat-icon>
</button>
<button mat-button color="primary" fxHide.md fxHide.lt-md (click)="userManual()">
  <mat-icon>book</mat-icon>
  User Manual
</button>
<button mat-button fxHide.gt-md href="javascript:void(0)" [matMenuTriggerFor]="menu">
  <mat-icon matTooltip="{{ userName }}">person</mat-icon>
</button>
<button mat-button fxHide.md fxHide.lt-md href="javascript:void(0)" [matMenuTriggerFor]="menu">
  <mat-icon>person</mat-icon>
  {{ userName }}
</button>
<mat-menu #menu="matMenu">
  <a (click)="changePassword()" mat-menu-item>
    <mat-icon>vpn_key</mat-icon>
    <span>Change Password</span>
  </a>
  <a (click)="passwordSecurity()" mat-menu-item>
    <mat-icon>security</mat-icon>
    <span>Password Security</span>
  </a>
  <a (click)="userProfile()" mat-menu-item>
    <mat-icon>account_circle</mat-icon>
    <span>User Profile</span>
  </a>
  <a (click)="logout()" mat-menu-item>
    <mat-icon>exit_to_app</mat-icon>
    <span>Sign Out</span>
  </a>
</mat-menu>
